import React from 'react';
import PropTypes from 'prop-types';
import ToolBar from 'react-big-calendar/lib/Toolbar';

class CustomToolbar extends ToolBar {

  render() {

    let navigate = {
      PREVIOUS:  'PREV',
      NEXT: 'NEXT',
      TODAY: 'TODAY',
      DATE: 'DATE'
    };
    let messages = {
      today: "Tänään",
      previous: "Edellinen",
      next: "Seuraava"
    };
    const styles = {
      width: "34%"
    };
    return (
        <div className='rbc-toolbar'>
          <span className='rbc-btn-group'>
            <button
                type='button'
                onClick={this.navigate.bind(null, navigate.PREVIOUS)}
            >
              {messages.previous}
            </button>
            <button
                type='button'
                onClick={this.navigate.bind(null, navigate.TODAY)}
            >
              {messages.today}
            </button>
            <button style={styles}
                type='button'
                onClick={this.navigate.bind(null, navigate.NEXT)}
            >
              {messages.next}
            </button>
          </span>
        </div>
    );
  }

  navigate (action) {
    super.navigate(action);
  }

  static propTypes = {
    messages: PropTypes.object
  }

}
export default CustomToolbar


// WEBPACK FOOTER //
// ../components/booking/CustomToolbar.js